import BlogCardsContainer from "../../../../Component/Application/blogs/BlogCards/BlogCards";

const BlogCards = () => {
  return (
    <div className="page-body">
      <BlogCardsContainer />
    </div>
  );
};

export default BlogCards;
